import { ENGLISH, SPANISH } from "../../utils/constants";

export const pageTitle = {
  [SPANISH]: "Productos",
  [ENGLISH]: "Products",
};

export const subTitle = {
  [SPANISH]: "Elegancia y comfort",
  [ENGLISH]: "Elegance and comfort",
};

export const ourGallery = {
  [SPANISH]: "Nuestra Galeria",
  [ENGLISH]: "Our Gallery",
};

export const askFor = {
  [SPANISH]: "Preguntar por este ",
  [ENGLISH]: "Ask for this ",
};

export const scheduleLabel = {
  [SPANISH]: "Horario",
  [ENGLISH]: "Schedule",
};

export const whatsAppMessage = {
  [SPANISH]:
    "Hola John, vengo a traves de tu pagina web para preguntarte por lo siguiente: ",
  [ENGLISH]:
    "Hello John, I come across your website to ask you about the following: ",
};
